module.exports = __webpack_public_path__ + "static/media/onehundredgoals.0234f739.jpg";